// Styles
import './styles.css';

// Core
import React, { Component } from 'react';
import {$stateParams } from '../../router';

// Components
import { 
    GeckoModalService,
    GeckoModal,
    GeckoIcon,
} from '@geckolabs/gecko-react-ui';
import Spinner from '../Spinner';
import SessionSingle from '../SessionSingle';
import SessionTime from '../SessionTime';

// Services
import EngageRequest from '../../services/EngageRequest';
import RsvpService from '../../services/RsvpService';
import GeckoStore from '../../services/GeckoStore';
import Utils from '../../services/utils/utils';
import DateUtils from '../../services/DateUtils';
import {__, STR_KEY} from '../../services/Translate';
import moment from 'moment';


export default class BookSessions extends Component {
    parent_event = null;

    rsvpService = new RsvpService();

    state = {
        sessions: [],
        loading: true,
        attendances: {},
        search: '',
    }

    componentDidMount()
    {
        this.fetch();    

        const attendances = this.getCurrentAttendedEvents();

        const attendances_by_id = attendances.reduce(function (accumulator, currentValue) {
            return Object.assign(accumulator, {[currentValue.event_id]: currentValue});
        }, {});

        this.setState({
            attendances: attendances_by_id,
        });
    }


    /* ==========================
    
        Helpers

    ========================== */

    fetch()
    {
        const params = {
            account_uuid: $stateParams.account_uuid,
            contact_uuid: $stateParams.contact_uuid,
            event_id: $stateParams.event_id,
        };

        EngageRequest.get(`/rsvp/${params.account_uuid}/${params.contact_uuid}/${params.event_id}/sessions`)
        .then((data) => {            
            this.setState({
                sessions: data,
                loading: false,
            });
        });
    }

    getCurrentAttendedEvents()
    {
        return GeckoStore.redux.get('attendances');
    }

    closeModal()
    {
        new GeckoModalService().close();
    }

    getParentEvent()
    {
        if (!this.parent_event) {

            let res = GeckoStore.redux.get('events').find((event, key) => {
                return Number($stateParams.eventId) === Number(event.id);
            });

            this.parent_event = res;
        }

        return this.parent_event;
    }

    isBooked(event)
    {
        if (!this.state.attendances[event.id]) {
            return false;
        }

        const state_attendance = this.state.attendances[event.id];

        if (state_attendance.status === 90 || state_attendance.status === 80) {
            return false;
        }

        return true;
    }

    renderPlaceholder()
    {
        return (
            <div className="row">
                <div className="col">
                    <div className="placeholder">
                        {__(STR_KEY.MODAL_BOOK_SESSION_FALLBACK)}
                    </div>
                </div>
            </div>    
        )
    }

    openSession(id = null) {

        const backButton = (this.props.backButton ? this.props.backButton : null);

        return new GeckoModalService().open(()=>{
            return (
                <GeckoModal className="modal-session-single" >
                    <SessionSingle id={id} backButton={backButton} event={this.props.event} />
                </GeckoModal>
            );
        }, {labelledBy: "sessionTitle"});
    }

    applyTags(session)
    {
        let tags = [
            session.title
        ];

        session.tags = tags.join(' ');

        return session;
    }

    /**
     * Return a boolean if the data matches the search term
     * 
     * @param string data - the string to be search
     * @param string term - the search term to look for
     * 
     * @return bool
     */
    filter(data, term = '')
    {
        let searchTerm = term;

        if(searchTerm === '') {
            return true;
        }

        // non alphanumerics can break the Regex so lets fail safe
        try {
            if(data && data.search(new RegExp(searchTerm, "i")) < 0) {
                return false;
            } else {
                return true;
            }
        } catch(err) {
            return true;
        };
    }

    /**
     * Remove sessions that are already attended and apply tags
     * to each session so the user can search them
     *
     * @param array sessions 
     *
     * @return array
     */
    prepareSessions(sessions)
    {
        return sessions.map((session) => {
            if (this.isBooked(session)) {
                return null;
            }

            session = this.applyTags(session);

            return session
        }).filter(n => n); // remove nulls
    }


    /* ==========================
    
        Renders

    ========================== */

    renderHeader()
    {   
        const account_bg = GeckoStore.redux.get('account').header_bg;

        // We dont want the green overlay if there is not background image
        let displayGradient = 'noDisplayGradient';

        let styles = {};
        if (account_bg) {
            styles.backgroundImage = `url(${account_bg})`;
            displayGradient = 'displayGradient';
        }

        return (
            <div className="sessionHeader" style={styles}>
                <div className={'gradientOverlay ' + displayGradient}>
                    <div className="row no-gutters controlsRow">
                        <div className="col d-flex justify-content-end">
                            <button className="closeModal" onClick={this.closeModal} tabIndex={0} aria-label="Close">
                                <GeckoIcon icon="times" />
                            </button>
                            {this.renderSearchField()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderFilters()
    {
        return (
            <div className="row filtersContainer">
                <div className="col">
                    {this.renderSearchField()}
                </div>
            </div>
        )
    }

    renderSearchField()
    {
        return(
            <div className="searchField">
                <label for="searchInput" id="searchLabel" style={{opacity: 0, position: "absolute"}}>
                    {__(STR_KEY.MODAL_BOOK_SESSION_SEARCH_PLACEHOLDER)}
                </label>
                <input 
                    id="searchInput"
                    autoFocus="true" 
                    placeholder={__(STR_KEY.MODAL_BOOK_SESSION_SEARCH_PLACEHOLDER)+'...'} 
                    value={this.state.search} 
                    onChange={(val) => this.setState({search: val.target.value})}
                    tabIndex={0}
                />
                <GeckoIcon icon="search" />
                <span className={'sr-only'}>search box</span>
            </div>
        )

    }

    renderSessions(sessions)
    {
        if (sessions.length === 0 && this.state.loading === false) {
            return this.renderPlaceholder();
        }

        // Sort by start date
        sessions = sessions.sort((a,b) => {
            return (a.start_datetime < b.start_datetime) ? -1 : (a.start_datetime > b.start_datetime) ? 1 : 0;
        });

        return sessions.map((session, key) => {
            if (!session.tags || this.filter(session.tags, this.state.search)) {
                return this.renderSession(session, key);
            }
            return null;
        })
    }

    getSessionTimes(sessions) {
        let sessionTimes = {};
        var format = 'YYYY-MM-DDTHH:mm:ss.SSS';
        sessions.forEach((session) => {
            let singleSessionTime = {};
            if (this.isBooked(session)) {
                singleSessionTime['title'] = session.title;
                singleSessionTime['start'] = moment(session.start_datetime, format);
                singleSessionTime['end'] = moment(session.end_datetime, format);
                sessionTimes[session.id] = singleSessionTime;
            }
        });
        return sessionTimes;
    }

    renderDate(session) {
        return DateUtils.dayMonthDateYear((session || {}).start_datetime);
    }

    handleOnKeyDown({keyCode}, session) {
        if (keyCode === 13 || keyCode === 32){
            this.openSession(session.id);
        }
    }

    renderSession(session, key)
    {
        if (this.isBooked(session)) {
            return null;
        }

        let closedWarning = null;

        const buildAriaLabel = (session) => {
            const stem = `View details for ${session.title}`;
            return stem;
        }

        return (
            <div key={key} className="singleSession">
                <div className="card materialCard" 
                tabIndex={0} 
                onClick={() => {this.openSession(session.id)}}
                onKeyDown={(event) => {this.handleOnKeyDown(event, session)}}
                role="button"
                aria-label={buildAriaLabel(session)}
                >
                    <div className="row">
                        {this.renderSessionTime(session)}

                        {/* title and location */}
                        <div className="col-sm-8 col-8 flex-column d-flex justify-content-center">
                            <div className="sessionInfo">
                                <h3 style={{marginBottom: '10px'}} className="sessionTitle">
                                    {session.title}
                                </h3>
                                <div>{this.renderDate(session)}</div>
                                {closedWarning}
                                {this.renderSessionChildren(session.children)}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }

    renderSessionChildren(value = null)
    {
        if (value && value > 1) {
            return (
                <div className="sessionChildren">
                    {value} {__(STR_KEY.MISC_SESSIONS)}
                </div>
            )
        }

        return null;
    }

    renderSessionTime(sessionTime) 
    {

        if (!sessionTime) {
            return null;
        }

        return <SessionTime start={sessionTime.start_datetime} end={sessionTime.end_datetime} className="stubSeparator col-sm-3" />;
    }

    renderLoader()
    {
        if(this.state.loading) {
            return (
                <div className="d-flex justify-content-center loaderContainer">
                    <Spinner />
                </div>
            );
        }
        return null;
    }

    render() {
        return (
            <div className="bookSessionModal">
                {this.renderHeader()}
                <div className="singleSessionContainer">
                    {this.renderSessions(this.prepareSessions(this.state.sessions))}
                </div>
                {this.renderLoader()}
            </div>
        );
    }
}


BookSessions.propTypes = {};
